<template>
<div>
  <div class="container-fluid">
    <div class="row mt17">
      <div class="col-sm-12">
        <data-table
          :title="title"
          :tableHeaders="tableHeaders"
          :radioFilter="radioFilter"
          :onAction="onAction"
          :rowActions="rowActions"
          :getData="getDonations"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DataTable from '@/components/shared/dataTable/DataTable'
import DatesFilter from '@/components/shared/inputs/DatesFilter'
import apiService from '@/services/ApiService'
import formatter from '@/mixins/Formatter'
import { donations as dataTable } from '@/components/npos/tables/settings'

export default {
  name: 'npo-donations',
  components: {
    DataTable,
    DatesFilter
  },
  mixins: [formatter],
  data() {
    return {
      title: this.$t('labels.donations'),
      selectedRow: {},
      selectedIndex: undefined,
      selectedPayment: {},
      ...dataTable
    }
  },
  methods: {
    ...mapMutations({
      goTo: 'goTo',
      setDonation: 'setDonation'
    }),
    getDonations: function(page, filters) {
      return apiService.getDonations({
        page: page - 1,
        ...filters,
        filters: JSON.stringify(filters.filters)
      })
    },
    onAction: function(action, row, index, rows) {
      switch (action) {
        case 'details':
          this.setDonation(row)
          this.goTo({ path: '/npos/donations/' + row._id })
          break
        default:
          break
      }
    }
  },
  computed: {
    ...mapState({
      route: state => state.route
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/npos/Donations.vue